import { render, staticRenderFns } from "./AudioFileBox.vue?vue&type=template&id=3ca83ce6&"
import script from "./AudioFileBox.vue?vue&type=script&lang=js&"
export * from "./AudioFileBox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports